<template>
  <div>
  <form @submit.prevent class="login-form-box register-page login-pagegap" lazy-validation>
    <div class="logo-img">
      
      <v-img
        max-height="60"
        max-width="230"
        :src="logo_image"
        :lazy-src="logo_image"
      >
      </v-img>
    </div>
    <h4 class="welcome-text">Create new account</h4>
    <v-row>
      <v-col>
        <v-text-field
          v-model="full_name"
          :error-messages="fullNameErrors"
          label="Full Name*"
          placeholder = "Enter Full Name"
          required
          @input="$v.full_name.$touch()"
          @blur="$v.full_name.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
            <v-col cols="12" md="12" class="col">
                <div class="select-radiobox">
                  <label class="laberbox">Gender (optional)</label>
                  <div>
                    <label class="container Female">
                      <input
                        type="radio"
                        checked="checked"
                        name="radio"
                        v-model="gender"
                        value="female"
                      />
                      <span class="checkmark">
                        Female
                      </span>
                    </label>
                    <label class="container male">
                      <input
                        type="radio"
                        checked="checked"
                        name="radio"
                        v-model="gender"
                        value="male"
                      />
                      <span class="checkmark">
                        Male
                      </span>
                    </label>
                    <label class="container other">
                      <input
                        type="radio"
                        checked="checked"
                        name="radio"
                        v-model="gender"
                        value="others"
                      />
                      <span class="checkmark">
                        Others
                      </span>
                    </label>
                   
                  </div>
                </div>
                 <span v-bind:class="{'error-messagebox-login': isAddClassServerError}">{{genderError}}</span>
            </v-col>
          </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        class="col"
      >
        <v-text-field
          v-model="email"
          :error-messages="emailErrors"
          label="Email Address*"
          placeholder = "Email Address"
          required
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
        ></v-text-field>
      </v-col>
      <v-col
      class="col mobile-box"
      cols="12"
      md="6"
      >
         <v-col
          class="d-flex"
        >
          <v-select
            v-model="country_code"
            :items="items"
            
            filled
            dense
            solo
            disabled
          ></v-select>
        </v-col>
        <v-text-field
          v-model="phonenumber"
          :error-messages="mobileErrorMsg"
          label="Mobile*"
          placeholder = "Enter Mobile No."
          :rules="[mobileRules.required,mobileRules.counter]"
          @blur="validateMobile"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col>
        <v-text-field  v-bind:class="{'pan-cardbox': isAddClass}"
          v-model="pancard"
          label="PAN (optional)"
          placeholder = "Enter PAN"
          @input="customPanError"
        ></v-text-field>
        <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="pan_side_error">{{panError}}</span>
      </v-col>
    </v-row> -->

   <!--  <v-row>
      <v-col class="dob-box">
        <label>DOB (optional)</label>
          <Datepicker 
          v-model="date" 
          :disabledDates="disabledDates" 
          format="dd MMM, yyyy"
          ></Datepicker>
          <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="server_side_error">{{dobError}}</span>
      </v-col>
    </v-row> -->

    <v-row>
     <v-col
       cols="12"
       md="6"
       class="relative col passwordbox">
       <v-text-field
         :type="show_password ? 'text' : 'password'"
         v-model="password"
         :error-messages="passwordErrors"
         label="Password*"
         :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
         placeholder = "Enter Password"
         @input="$v.password.$touch()"
         @blur="$v.password.$touch()"
         @click:append="show_password = !show_password"
       ></v-text-field>
     </v-col>
     <v-col
       cols="12"
       md="6"
       class="relative col passwordbox">
       <v-text-field
         placeholder = "Enter Confirm Password"
         class="relative"
         :type="show_confirm_password ? 'text' : 'password'"
         :append-icon="show_confirm_password ? 'mdi-eye' : 'mdi-eye-off'"
         v-model="confirmPassword"
         :error-messages="confirmPasswordErrors"
         label="Confirm Password*"
         @input="$v.confirmPassword.$touch()"
         @blur="$v.confirmPassword.$touch()"
         @click:append="show_confirm_password = !show_confirm_password"
       ></v-text-field>
     </v-col>
     <span class="hint-msg">Min. 8 characters with 1 Capital, 1 lower letters, 1 number & special character.</span>
   </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="refferal_code"
          label="REFERRAL/EMPLOYEE CODE (optional)"
          placeholder = "Enter referral/employee code"
          required
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row class="register-checkbox">
        <v-checkbox
          id="checkboxfield"
          v-model="checkboxfield"
          :error-messages="checkboxfieldsErrors"
          label=""
          required
          @input="$v.checkboxfield.$touch()"
          @blur="$v.checkboxfield.$touch()"
          color="orange"
          value="orange"
          hide-details
        ></v-checkbox>
          I agree to the
        <v-btn @click="openTermOfServices" class="terms-policy-link">
              Terms of Services 
        </v-btn>
        &
        <v-btn @click="openPrivacyAndPolicy" class="terms-policy-link">
              Privacy Policy
        </v-btn>
    </v-row>
    <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="server_side_error">{{serverError}}</span><span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="aws_side_error">{{frontEndError}}</span>
    <v-row class="mt-0">
      <v-col>
        <v-btn class="blue-btn"
          @click="submit" :disabled="!isFormValid" :error-messages="buttonErrorMessage">
          sign up    
        </v-btn>
      </v-col>
    </v-row>
    <div class="sign-up-link login-link">
      <p>Already have an account?
        <button @click="login" type="button" class="btn btn-secondary">Login
        </button>
      </p>
    </div>
  </form>
  <modal class="common-modal-box" name="termsandservices"> 
    <span> 
      <v-img width="20" height="20" @click="close" style="float: right;" :src="require('@/assets/images/cross.png')">
      </v-img>
    </span>
    <h4>Terms of Service</h4>
    <p><strong>1.</strong> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
    <p><strong>2.</strong> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
    <p><strong>3.</strong> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
    <p><strong>4.</strong> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
  </modal>
  <modal name="privacy-policy" class="common-modal-box"> 
    <span> 
      <v-img width="20" height="20" @click="closePrivacyPolicy" style="float: right;" :src="require('@/assets/images/cross.png')">
      </v-img>
    </span>
    <h4>Privacy Policy</h4>
    <p><strong>1.</strong> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
    <p><strong>2.</strong> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
    <p><strong>3.</strong> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
    <p><strong>4.</strong> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
  </modal>
</div>

</template>
<script>
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
  numeric
} from "vuelidate/lib/validators";
import { Auth } from "aws-amplify";
import Datepicker from 'vuejs-datepicker'
import { REGISTRATION_DATA, USER_DETAILS } from "../../store/actions.type";
import JwtService from ".././common/jwt.service";
import axios from "axios";

export default {
  components: {
        Datepicker
    },
  mixins: [validationMixin],
  validations: {
    full_name:{ required, maxLength: maxLength(50), validateAlpha:function(value){
        const alpha_str = /^[a-zA-Z\-\s]+$/.test(value)
        return alpha_str 
    }},
    email: { required, email},
    password: { 
      required,
      minLength: minLength(8),
      validateString: function(value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber    = /[0-9]/.test(value)
          const containsSpecial   = /[#?!@$%^&*-]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
      } 
    },
    confirmPassword:{ required, sameAsPassword: sameAs('password')},
    checkboxfield:{ required }
  },

  data: () => ({
    full_name: "",
    email: "",
    phonenumber: "",
    pancard: "",
    password: "",
    confirmPassword: "",
    passwordType:'password',
    confirmPasswordType:'password',
    submitted: false,
    isAddClass: false,
    seen: false,
    checkboxfield:'',
    show_password:false,
    show_confirm_password:false,
    items: ['+91'],
    country_code: '+91',
    serverError:'',
    activePicker: null,
    date: null,
    menu: false,
    frontEndError:'',
    isFormValid:false,
    disabledDates: {
          from: new Date()
        },
    isAddClassServerError:false,
    logo_image:process.env.VUE_APP_ROOT_ICONS_URL + 'Logo.png',
    dobError:'',
    gender: "",
    genderError:'',
    refferal_code: '',
    panError:'',
    final_ref_code:'',
    mobileErrorMsg:'',
    mobileRules: {
      required: value => !!value || 'Mobile number required.',
      counter: value => value.length == 10 || 'Mobile number must be 10 digit.'
    },
  }),

   watch: {
      menu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
    },
    beforeCreate (){
      
    },
    created(){
      console.log(window.location.origin)
      if(this.$route.query.referral_code != undefined && this.$route.query.referral_code != ''){
        this.refferal_code = this.$route.query.referral_code;
      }
    },

  computed: {
    fullNameErrors() {
      const errors = [];
      this.serverError='';
      if (!this.$v.full_name.$dirty) return errors;
      !this.$v.full_name.required && errors.push("Full name is required.");
      !this.$v.full_name.maxLength && errors.push("Full name can't be greater than 50 characters.");
      !this.$v.full_name.validateAlpha && errors.push("Full name must be alphabet.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      this.serverError='';
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid email.");
      !this.$v.email.required && errors.push("Email is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      this.serverError='';
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required.");
      !this.$v.password.minLength && errors.push("Password must be at least 8 characters.");
      !this.$v.password.validateString && errors.push("Password must contain one alphabet, one uppercase, one lowecase, one number and one special character.");
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      this.serverError='';
      if (!this.$v.confirmPassword.$dirty) return errors;
      !this.$v.confirmPassword.required && errors.push("Confirm Password is required.");
      this.$v.confirmPassword.required && !this.$v.confirmPassword.sameAsPassword  && errors.push("Confirm password must match with password.");
      return errors;
    },
    checkboxfieldsErrors() {
      const errors = [];
      this.serverError='';
      if (!this.$v.checkboxfield.$dirty) return errors;
      !this.$v.checkboxfield.required && errors.push("Please agree to the Terms of Services & Privacy Policy.");
      if (!this.$v.checkboxfield.required) {
        this.isAddClassServerError = true;
        this.frontEndError = 'Please agree to the Terms of Services & Privacy Policy.';
      }else{
        this.isAddClassServerError = false;
        this.frontEndError = '';
      }
      return errors;
    },
    buttonErrorMessage(){
      if (this.$v.$invalid) {
        this.isFormValid = false;
      }
      else{
        this.isFormValid = true;
        if (!this.gender) {
           this.isFormValid = false;
           this.genderError = 'Gender is required';
           this.isAddClassServerError = true;
        }
        else{
            this.isFormValid = true;
            this.genderError = '';
            this.isAddClassServerError = false;
        }
      }
      if (!this.phonenumber || this.phonenumber.length != 10) {
        this.isFormValid = false;
      }
    },
  },

  methods: {
    customPanError(){
      const panStr = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(this.pancard)
      if(this.pancard == ""){
        this.panError = '';
      }else if(panStr){
        this.isAddClass = true;
        this.panError = '';
      }
      else{
        this.isAddClassServerError = true;
        this.isAddClass = false;
        this.panError = 'Invalid PAN number.';
      }
    },
    save (date) {
        this.$refs.menu.save(date)
      },
    close(){
        this.$modal.hide("termsandservices");
      },
    // closePrivacyPolicy(){
    //     this.$modal.hide("privacy-policy");
    //   },
    // openTermOfServices(){
    //   this.$modal.show("termsandservices");
    // },
    openTermOfServices(){
        window.open('https://nimeya.ai/terms-and-conditions','_blank');
    },
    openPrivacyAndPolicy(){
     // this.$modal.show("privacy-policy");
     window.open('https://nimeya.ai/pages/privacy-policy','_blank');
    },
    submit(e) {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.$loading(true)
        // let user_data = { 
        //   user_name: this.full_name,  
        //   cognito_idp: '', 
        //   mobile_no: this.phonenumber,
        //   photo: '',
        //   email:this.email,
        //   password:this.password,
        //   profile_name:this.full_name,
        //   profile_image:'',
        //   selected_value:''
        // };
        // this.updateAuthUser('commitData', user_data)
        let user_details = {
          user_name: this.full_name,
          email:this.email,
          mobile_no: '+91'+this.phonenumber,
          password: this.password,
          profile_name:this.full_name,
          member_id:'',
          profile_image:'',
          selected_value:'',
          cognito_idp: '', 
        }
        this.$store.dispatch(USER_DETAILS, user_details)
        let authSingup =  Auth.signUp({ 'username': this.email, 'password': this.password, 'attributes': {
          'custom:name':this.full_name,'custom:phonenumber':'+91'+this.phonenumber,'custom:pancard':this.pancard,'custom:birth':this.$moment(this.date).format('DD MMM, YYYY'),'custom:gender': this.gender
         } 
        }).then(data => {
          localStorage.setItem('email',this.email);
            console.log(this.$route.query.referral_code)
            localStorage.setItem('cognito_idp',btoa(data.userSub))
            
            if(this.refferal_code !=''){
              this.final_ref_code = this.refferal_code;
            }
            else if(this.$route.query.referral_code == undefined || this.$route.query.referral_code == ''){
              this.final_ref_code = '';
            }
            else{
              this.final_ref_code = this.$route.query.referral_code;
            }
            
           
            this.$store.dispatch(REGISTRATION_DATA, {
                data: {
                  aws_cognito_id: data.userSub,
                  device_iemi_no: data.userSub,
                  firebase_token: data.userSub,
                  device_info: "Desktop",
                  referral_code:this.final_ref_code,
                  name: this.full_name,
                  email: this.email,
                  mobile_no: "+91" + this.phonenumber,
                },
                api: 'register',
            }).then(() => {
              if (this.$store.getters.getRegistrationData.status == 'error') {
                this.serverError = this.$store.getters.getRegistrationData.message;
                return [];
              }else{
                JwtService.setToken(btoa(this.$store.getters.getRegistrationData.data["token"]));
                localStorage.setItem("api_token",btoa(result.data['token']));
              }
            })
            .catch((error) =>  {
              this.$v.$reset()
              this.$v.$touch()
              this.$loading(false);
            });
            this.$loading(false);
            this.$router.push({ name: 'VerifyOtp' });
        })
        .catch((error) =>  {
          if(error.message == 'An account with the given email already exists.'){
            this.resendToEmailVerify();
            this.$loading(false);
          }else{
            this.$loading(false);
            this.isAddClassServerError = true;
            this.serverError  = error.message; 
          }
        });
    },
    login(evt){
      evt.preventDefault();
      this.$router.push({ name: 'Login' });
    },
    resendToEmailVerify () {
      this.$loading(true);
      let username  = this.email;
      Auth.resendSignUp(username).then((sendCode) => {
        this.$loading(false);
        this.$router.push({ name: 'VerifyOtp' });
     }).catch((error) => {
      if(error.message == 'User is already confirmed.'){
        // this.$router.push({ name: 'Login' });
        this.$loading(false);
        this.isAddClassServerError = true;
        this.serverError  = 'Already registered. Please proceed with login.'; 
      }else{
        this.$loading(false);
        this.serverError  = error.message; 
      }
     });
    },
    validateMobile(){
      let formdata = new FormData();
      formdata.append("mobile_no", this.country_code+this.phonenumber);
      axios.post(process.env.VUE_APP_ROOT_API + 'validate-mobile', formdata).then((res) => {
        if(this.phonenumber && res.data.status == 'error'){
          this.mobileErrorMsg = res.data.message;
          this.isFormValid = false;
        }
        else {
          this.mobileErrorMsg = '';
        }
      });
    }
  }
};
</script>

<style >
    .v-application .error--text {
        color: #ff5252 !important;
    }
  
  
  .register-checkbox .v-input--selection-controls__input input {
      top: 0px;
      height: 24px !important;
      width: 24px !important;
      min-height: auto;
  }
  
  .register-checkbox .v-input--selection-controls__input .v-input--selection-controls__ripple {
      width: 24px;
      height: 24px;
      left: 0px;
      top: 0px;
      margin: 0px !important;
      border-radius: 0px !important;
      overflow: hidden;
  }
  
  span#pan_side_error {
      margin-top: 0px;
      position: relative;
      bottom: 12px;
  }
  
  </style>